import { Button } from "@/src/components/ui/button";
import { operatorGoodToKnowMapper } from "../../BookingDetails";
import { Card } from "@/src/components/wrappers/Card";
import { Booking, Operator } from "../../model";
import { useState } from "react";
import { EditBookingGoodToKnowModal } from "../../EditBookingGoodToKnow";

/** HubSpot deal charter types -> the three good-to-know variants (imported
 *  bookings have no offer to read charterType from). */
const charterTypeFromDeal = (t?: string | null) => {
  const s = String(t ?? "").toLowerCase();
  if (/crew|gulet|hostess|cabin/.test(s)) return "crewed";
  if (/skipper/.test(s)) return "skippered";
  if (/bareboat|flotilla|day/.test(s)) return "bareboat";
  return "";
};

const GoodToKnowSection = ({ booking, operator }: { booking: Booking; operator?: Operator }) => {
  const [updateGoodToKnow, setUpdateGoodToKnow] = useState(false);

  // The booking's own text wins; otherwise the operator's text for this charter
  // type. (Previously the operator's text showed only when the booking HAD its
  // own, the booking's own never showed, and booking.offer.charterType crashed
  // on bookings without an offer.)
  const charterType = booking?.offer?.charterType ?? charterTypeFromDeal(booking?.importDetails?.charterType);
  const operatorGoodToKnow = operator?.goodToKnow ? operatorGoodToKnowMapper(charterType, operator.goodToKnow) : null;

  return (
    <Card className="w-full flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Good to know</h3>
        <Button
          onClick={() => {
            setUpdateGoodToKnow(true);
          }}
          variant="link"
        >
          Edit
        </Button>
      </div>
      <p>{booking?.goodToKnow || operatorGoodToKnow || "No data"}</p>
      {updateGoodToKnow && (
        <EditBookingGoodToKnowModal
          open={updateGoodToKnow}
          setOpen={setUpdateGoodToKnow}
          initialGoodToKnow={booking?.goodToKnow || operatorGoodToKnow || ""}
          bookingId={booking?.id}
        />
      )}
    </Card>
  );
};

export default GoodToKnowSection;
